export enum PAGE_HEADER_VARIANTS {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  STICKY = 'sticky',
  TERTIARY = 'tertiary',
}
